import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface DeleteTaskModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  taskTitle: string;
  studentName?: string;
  darkMode?: boolean;
}
export const DeleteTaskModal: React.FC<DeleteTaskModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  taskTitle,
  studentName,
  darkMode = true
}) => {
  if (!isOpen) return null;
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-1209">
      <div className={`relative w-full max-w-md rounded-xl shadow-2xl ${darkMode ? 'bg-navy-800 text-white' : 'bg-white text-gray-900'}`} data-id="element-1210">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-700" data-id="element-1211">
          <div className="flex items-center gap-3" data-id="element-1212">
            <div className="p-2 bg-red-500/10 rounded-lg" data-id="element-1213">
              <AlertTriangleIcon className="h-6 w-6 text-red-500" data-id="element-1214" />
            </div>
            <h2 className="text-xl font-semibold" data-id="element-1215">Delete Task</h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-700/50 transition-colors" data-id="element-1216">
            <XIcon className="h-5 w-5" data-id="element-1217" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4" data-id="element-1218">
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'} data-id="element-1219">
            Are you sure you want to delete this task?
          </p>

          <div className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'}`} data-id="element-1220">
            <p className="font-medium" data-id="element-1221">{taskTitle}</p>
            {studentName && <p className={`text-sm mt-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-1222">
                Student: {studentName}
              </p>}
          </div>

          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-1223">
            This action cannot be undone.
          </p>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-gray-700" data-id="element-1224">
          <button onClick={onClose} className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${darkMode ? 'bg-navy-900/50 hover:bg-navy-900 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'}`} data-id="element-1225">
            Cancel
          </button>
          <button onClick={handleConfirm} className="flex-1 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors" data-id="element-1226">
            Delete Task
          </button>
        </div>
      </div>
    </div>;
};